import PropTypes from "prop-types";
import React from "react";
import SelectField from "components/form/select-field";
import MenuItem from "material-ui/MenuItem";
import IconMenu from "material-ui/IconMenu";
import IconButton from "material-ui/IconButton";
import { Form } from "formsy-react";
import SortIcon from "components/icons/sort";
import { VIEWPORT_PHABLET, VIEWPORT_MOBILE, VIEWPORT_TABLET } from "constants/media";
import { SortNew } from "components/icons/dashboard/sort-new";

const Sort = ({
    value,
    onChange,
    name = "sort",
    style = undefined,
    onClick = undefined,
    choices = [],
    viewport = undefined,
    useNewIcon = undefined,
    tooltip = undefined,
    label = undefined,
    Icon = undefined,
    labelKey = undefined,
}) => {
    const options = choices.map((choice) => (
        <MenuItem
            data-test={choice[1].replace(/\s+/g, "-").toLowerCase()}
            key={choice[0]}
            value={choice[0]}
            primaryText={choice[1]}
        />
    ));

    if (viewport === VIEWPORT_PHABLET || viewport === VIEWPORT_MOBILE || viewport === VIEWPORT_TABLET) {
        return (
            <IconMenu
                iconButtonElement={
                    <IconButton tooltip={tooltip}>
                        <SortIcon />
                    </IconButton>
                }
                onChange={onChange}
                value={value}
                style={{ top: "-4px" }}
            >
                {options}
            </IconMenu>
        );
    }

    if (useNewIcon || Icon) {
        return (
            <IconMenu
                className="sortIcon"
                style={style}
                iconButtonElement={<IconButton tooltip={tooltip}>{Icon ? <Icon /> : <SortNew />}</IconButton>}
                onChange={onChange}
                value={value}
            >
                {options}
            </IconMenu>
        );
    }

    return (
        <Form style={style}>
            {label && <div className="dropdownLabel">{label}</div>}
            <SelectField
                data-test={labelKey}
                baseClassName="dropdownContainer"
                value={value}
                onChange={onChange}
                onClick={onClick}
                name={name}
                style={{ width: "100%" }}
            >
                {options}
            </SelectField>
        </Form>
    );
};

Sort.propTypes = {
    viewport: PropTypes.string,
    choices: PropTypes.array.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string,
    style: PropTypes.object,
};

export default Sort;
